// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9UbQB","top":"styles_top__1nA1f"};